import { render, staticRenderFns } from "./AftSale.vue?vue&type=template&id=2053e53e&"
import script from "./AftSale.vue?vue&type=script&lang=js&"
export * from "./AftSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports